import React from "react";
import { SkillLevel } from "./SkillLevel.js";
import { levelDescriptions } from "./questions.js";

export function Instructions() {
  return (
    <section>
      <p className="content-area">
        This tool enables guidance professionals, teams, multidisciplinary
        networks, and organisations to assess their guidance competence in
        relation to the
        <span className="italics">
          {" "}
          National Competency Framework for Career Professionals.{" "}
        </span>
        You can find detailed competence description for each competence
        statements by clicking on the &#9432; button. The information provided in the evaluation form will not be stored.
      </p>
      <h3 className="bold">Instructions</h3>
      <div className="content-area">
        <span className="bold">First round: your current competency</span>{" "}
        <p>
          To evaluate your current competence, please fill in the form below.
          Read the competence statements in the assessment form and select the
          level (0-3) that best describes your competence at the time of
          assessment. The competency levels are described in the box below. Once
          you have responded to all competence statements, you will receive a
          visual competency profile.
        </p>
      </div>
      <div className="content-area">
        <span className="bold">Second round: setting competency goals</span>
        <p>
          You have the option to revisit the competency statements and define
          your competency goals for each competency area. The competency levels
          you previously selected for each competence area will be visible
          beneath the each statement. Upon completion, you will receive a visual
          competency profile illustrating both your current competency and the
          set competency goals.
        </p>
      </div>
      <div className="box info-box">
        <div className="content-area">
          <h3>Competency levels </h3>
          {Object.values(levelDescriptions).map((description) => (
            <SkillLevel key={description.header} level={description} />
          ))}
          <p className="italics">
          By moving the mouse pointer over the competency level value, the tool will display the corresponding description. 
          </p>
        </div>
      </div>
    </section>
  );
}
